import { createContext, useContext, useEffect, useRef, useState, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ComplianceContext = createContext({
  indicators: {},
  loading: true,
  refresh: () => {},
});

export function ComplianceProvider({ children }) {
  const [indicators, setIndicators] = useState({});
  const [loading, setLoading] = useState(true);
  const inFlight = useRef(false);

  const fetchIndicators = useCallback(async () => {
    if (inFlight.current) return;
    inFlight.current = true;
    try {
      const r = await axios.get(`${API}/admin/employees-compliance/indicators`);
      setIndicators(r.data || {});
    } catch (e) {
      // Non-fatal: indicators just won't render. Silently swallow so
      // non-admin pages and unauthenticated states don't spam errors.
      setIndicators({});
    } finally {
      setLoading(false);
      inFlight.current = false;
    }
  }, []);

  useEffect(() => {
    fetchIndicators();
    // Refresh every 60s so the indicator reflects newly approved docs
    // / completed acknowledgements without forcing a manual page reload.
    const id = setInterval(fetchIndicators, 60_000);
    return () => clearInterval(id);
  }, [fetchIndicators]);

  return (
    <ComplianceContext.Provider value={{ indicators, loading, refresh: fetchIndicators }}>
      {children}
    </ComplianceContext.Provider>
  );
}

export function useCompliance(userId) {
  const ctx = useContext(ComplianceContext);
  return {
    data: userId ? ctx.indicators[userId] : null,
    loading: ctx.loading,
    refresh: ctx.refresh,
  };
}
